module.exports = __webpack_public_path__ + "static/197a3067-5a04-4413-9d99-9ff2f72581a2-450.a16af9c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/sir-hugh-holy-trinity-northwood/197a3067-5a04-4413-9d99-9ff2f72581a2-450.jpg
// module id = 1065
// module chunks = 168707334958949